import {fileTypeFromBlob} from 'file-type';

const cache = new WeakMap<Blob, Promise<{mime: string, ext: string}|undefined>>();

export async function getFileMimeType(file: Blob): Promise<string|undefined> {
 return (await getFileType(file))?.mime;
}

export async function getFileType(file: Blob): Promise<{mime: string, ext: string}|undefined> {
  if (cache.has(file)) {
    return cache.get(file);
  }

  // No feature detection and no arrayBuffer() fallback. Since file-type 20 this reads through
  // strtok3's BlobTokenizer, which does blob.slice(pos, pos + n).arrayBuffer() over a ~4 kB
  // window; it never constructs a ReadableStreamBYOBReader. The Safari branch this used to carry
  // guarded against a limitation that is no longer there - and paid for it by reading the whole
  // file into memory to look at its first few bytes.
  const result = fileTypeFromBlob(file);

  cache.set(file, result);
  // A failed sniff must not poison the Blob forever. The cache holds the *promise*, so without
  // this a single rejection - a File whose backing bytes went away between selection and read,
  // say - is replayed to every later caller, and callers that treat "couldn't sniff" as fatal
  // would keep failing a file that would sniff fine on a retry.
  result.catch(() => cache.delete(file));
  return await result;
}

export async function isOfMimeType(file: File, types: string[]): Promise<boolean>;
export async function isOfMimeType(file: File, type: string, ...types: string[]): Promise<boolean>;
export async function isOfMimeType(file: File, typeOrTypes: string|(string[]), ...types: string[]): Promise<boolean> {
  const mime = await getFileMimeType(file);
  if (!mime) {
    return false;
  }
  types = Array.isArray(typeOrTypes) ? typeOrTypes : [typeOrTypes, ...types];
  return types.includes(mime);
}
